// Import utilities
const {
	isDefined,
	isEmpty,
	getURLParameter
} = _uo.utility;

import { getDOMElements } from '../common/utilities.js';
import { getActions } from '@builder-legacy/item/actions/utilities';

import MakeSortable from '@builder-legacy/item/sortability/make-sortable';

import UserSelector             from '../user-selector/user-selector.js';

import MetaboxItems             from '../metabox/items.js';
import MetaboxFooter            from '../metabox/footer.js';

import ItemInitialAction        from './item-initial-action.js';
import Closures                 from './closures.js';
import ItemCreatorIntegrations  from './integrations-grid.js';

import RenderConditions from '@builder-legacy/item/conditions/render';

export default class Actions {
	/**
	 * Renders all the actions in the UI
	 */
	constructor(){
		// Clear the metabox
		this.clearActionsMetabox();

		// Check if we have to create the User Selector
		if ( UncannyAutomator._recipe.recipe_type == 'anonymous' ){
			// Create User Selector
			new UserSelector();
		}

		// Check if it has actions
		if ( this.hasLoops || ! isEmpty( getActions( {} ) ) || ! isEmpty( UncannyAutomator.recipe.conditions ) ) {
			// Check if it's Pro
			if ( UncannyAutomator._site.automator.has_pro ) {
				// Render delayed, scheduled and filtered actions
				this.renderProUI();
			} else {
				// Render simple UI
				this.renderFreeUI();
			}
		}
		else {
			this.renderAddNewAction();
		}
	}

	/**
	 * Renders delayed, scheduled and filtered actions
	 */
	renderProUI() {
		// Get actions
		const actions = {
			instant: getActions( { type: 'instant' } ),
			delayed: getActions( { type: 'delayed' } ),
			scheduled: getActions( { type: 'scheduled' } ),
			delayedCustom: getActions( { type: 'delay-custom' } ),
		}

		// Create loops element
		const $loopsWrapper   = document.createElement( 'div' );
		const $actionItemList = document.createElement( 'uap-builder-item-action-list' );
		$actionItemList.runOn = UncannyAutomator._recipe.actions.runOn;
		$actionItemList.items = UncannyAutomator._recipe.actions.items;

		// Check if it has delayed or scheduled actions
		if ( ! isEmpty( actions.delayed ) || ! isEmpty( actions.scheduled ) || ! isEmpty( actions.delayedCustom ) ) {
			// Render instant actions
			new MetaboxItems( 'action', actions.instant, {
				wrapperClass: 'uap-items--actions-instant'
			} );
			
			// Add Closures
			// Add action button
			new MetaboxFooter( 'action' );

			// Add loops
			getDOMElements( 'metabox', { type: 'action' } ).get(0).appendChild( $loopsWrapper );
			
			new Closures( UncannyAutomator._core.i18n.action.asyncActions.closuresLabelAsyncOnly );
			
			// Render async actions
			new MetaboxItems( 'action', actions.delayed, {
				wrapperClass: 'uap-items--actions-delayed'
			} );

			new MetaboxItems( 'action', actions.scheduled, {
				wrapperClass: 'uap-items--actions-scheduled'
			} );

			new MetaboxItems( 'action', actions.delayedCustom, {
				wrapperClass: 'uap-items--actions-delayed-custom'
			} );

			$loopsWrapper.appendChild( $actionItemList );
		} else {
			// Render non-async actions
			new MetaboxItems( 'action', actions.instant, {
				wrapperClass: 'uap-items--actions-instant'
			} );

			// Add action button
			new MetaboxFooter( 'action' );

			// Add loops
			getDOMElements( 'metabox', { type: 'action' } ).get(0).appendChild( $loopsWrapper );

			// Add closures
			new Closures( UncannyAutomator._core.i18n.action.asyncActions.closuresLabelAsyncOnly );

			$loopsWrapper.appendChild( $actionItemList );
		}

		// Render conditions
		new RenderConditions();

		// Check if we have to show the integrations on load
		if ( this.isContinuingIntegrationConnection() ){
			// Check if the user wants to add the new action inside a condition
			const conditionsGroupID = getURLParameter( null, 'ua_connecting_integration_condition' );
			const integrationGridAttributes = {}

			if ( ! isEmpty( conditionsGroupID ) ) {
				integrationGridAttributes.conditionsGroupID = conditionsGroupID;
			}

			// Render the integrations list
			new ItemCreatorIntegrations( 'action', null, integrationGridAttributes ); 
		}

		// Make the actions and conditions sortable
		new MakeSortable();
	}

	/**
	 * Renders all actions in order. Don't separate them based on filters or delay
	 */
	renderFreeUI() {
		// Get all actions
		const actions = getActions( {} );

		new MetaboxItems( 'action', actions, {
			wrapperClass: 'uap-items--actions-instant'
		} );

		// Add action button
		new MetaboxFooter( 'action' );

		// Check if we have to show the integrations on load
		if ( this.isContinuingIntegrationConnection() ){
			// Render the integrations list
			new ItemCreatorIntegrations( 'action' );
		}

		// Add closures
		new Closures( UncannyAutomator._core.i18n.action.asyncActions.closuresLabelAsyncOnly );

		// Make the actions and conditions sortable
		new MakeSortable();
	}

	/**
	 * Renders the first step, where the user only sees one button to add the first action
	 */
	renderAddNewAction() {
		// Render the first step of the item creator
		new ItemInitialAction();

		// Check if we have to show the integrations on load
		if ( this.isContinuingIntegrationConnection() ){
			// Render the integrations list
			new ItemCreatorIntegrations( 'action' );
		}
		
		// Add closures
		new Closures( UncannyAutomator._core.i18n.action.asyncActions.closuresLabelAsyncOnly );
	}

	/**
	 * Connect integration
	 * We'll use this to continue with the process of connecting a premium integration after reloading the page
	 * 
	 * @return {Boolean} `true` if it should conitnue with the connection process. This will open the dialog.
	 */
	isContinuingIntegrationConnection(){
		return getURLParameter( null, 'ua_connecting_integration' ) == 1 && getURLParameter( null, 'ua_connecting_integration_context' ) == 'action';
	}

	/**
	 * Clears all the content of the actions metabox
	 */
	clearActionsMetabox() {
		// Get and clear metabox
		let $metabox = getDOMElements( 'metabox', { type: 'action' } ).get(0);
		$metabox.innerHTML = '';
	}

	get hasLoops () {
		return UncannyAutomator._recipe.actions.items.filter( item => item.type === 'loop' ).length > 0;	
	}
}
